<template>
    <!-- 页面跳转加载效果 -->
    <div v-if="isRequesting" class="modal-loading">
        <div class="loadBox">
            <div class="loading loading-bg">
                <div class="loader"></div>
            </div>
        </div>
    </div>
    <Transition name="modal">
        <div v-if="visible" class="modal-overlay" @click="onClose">
            <Transition name="slide-up">
                <div class="modal-content" @click.stop>
                    <div class="modal-header-top">


                        <div class="modal-header">
                            <Transition name="fade-slide" mode="out-in">
                                <button v-if="view === 'chains'" key="back-btn" type="button" class="back-btn"
                                    @click="backToMethods">
                                    <img class="back-icon" src="@/components/payMent/img/arrow-right.svg" alt="<" />
                                </button>
                            </Transition>
                            <Transition name="fade-slide" mode="out-in">
                                <h2 v-if="view === 'methods'" key="methods-title" class="modal-title">Select Payment
                                    Method:</h2>
                                <h2 v-else key="chains-title" class="modal-title">Select Chain:</h2>
                            </Transition>
                        </div>
                        <div class="close-btn" @click="onClose">
                            <img src="@/assets/icon/close.svg" alt="关闭" />
                        </div>
                    </div>
                    <!-- 内容区域容器 -->
                    <div class="content-container">
                        <!-- 支付方式列表 -->
                        <Transition name="slide-horizontal" mode="out-in">
                            <div v-if="view === 'methods'" key="methods" class="methods-grid">
                                <button v-for="(m, index) in renderMethods" :key="m.id || index" class="method-item"
                                    :class="{ full: index < 2 }" type="button" @click="onSelectMethod(m)">
                                    <span class="left">
                                        <span class="icon-wrapper">
                                            <img v-if="m.icon" :src="m.icon" :alt="m.name" />
                                            <span v-else class="icon-text">{{ m.name }}</span>
                                        </span>
                                        <span class="name">{{ m.name }}</span>
                                    </span>
                                    <img class="chevron" src="@/components/payMent/img/arrow-right.svg" alt=">" />
                                </button>
                            </div>

                            <!-- 链列表 -->
                            <div v-else key="chains" class="chains-list">
                                <button v-for="(c, idx) in (selectedMethod?.chains || [])" :key="c.id || idx"
                                    class="chain-item" type="button" @click="onSelectChain(c)">
                                    <span class="left">
                                        <span class="icon-wrapper">
                                            <img v-if="c.icon || selectedMethod?.icon"
                                                :src="c.icon || selectedMethod?.icon" :alt="chainName(c)" />
                                            <span v-else class="icon-text">{{ chainName(c) }}</span>
                                        </span>
                                        <span class="name">{{ chainName(c) }}</span>
                                    </span>
                                    <span class="token">{{ chainToken() }}</span>
                                </button>
                            </div>
                        </Transition>
                    </div>

                </div>
            </Transition>
        </div>
    </Transition>
</template>

<script setup>
import { computed, defineEmits, defineProps, ref } from 'vue';
import { useConfigStore } from '@/store/config';
import { createInvoice } from '@/components/payMent/payment';
import { getCacheV1, getUrl, setCacheV1 } from "@/utils/common";
import { useI18n } from 'vue-i18n';
const configStore = useConfigStore();
const { t } = useI18n();

const props = defineProps({
    visible: {
        type: Boolean,
        default: false
    },
    amount: {
        type: Number,
        default: null
    },
    content_type: {
        type: Number,
        default: 1
    },
    sku_id: {
        type: String,
        default: null
    }
});

const emit = defineEmits(['close', 'select']);
const renderMethods = computed(() => configStore.invoice_list);

const onClose = () => {
    emit('close');
    // 重置视图，避免下次打开还停留在链列表
    view.value = 'methods';
    selectedMethod.value = null;
};

// 视图状态：methods（方式列表）/ chains（网络列表）
const view = ref('methods');
const selectedMethod = ref(null);

const onSelectMethod = (method) => {
    const chains = Array.isArray(method?.chains) ? method.chains : [];
    if (chains.length > 1) {
        selectedMethod.value = method;
        view.value = 'chains';
        return;
    }
    if (chains.length === 1) {
        // 单链：直接发起请求
        startInvoice(method, chains[0]);
        return;
    }
    // 没有链信息，直接按方式发起
    startInvoice(method, null);
};

const onSelectChain = (chain) => {
    // 多链选择后：发起请求
    startInvoice(selectedMethod.value, chain);
};

const backToMethods = () => {
    view.value = 'methods';
    selectedMethod.value = null;
};

const chainName = (chain) => chain?.name || chain?.network || chain?.chain_name || chain?.id || 'Unknown';
// 右侧展示代币名，如：USDT。优先取支付方式的 name。
const chainToken = () => selectedMethod.value?.name || selectedMethod.value?.token?.toUpperCase() || 'USDT';

// 发起创建发票请求
const isRequesting = ref(false);
const startInvoice = async (method, chain) => {
    let invoice_cache_key = `payment_${props.sku_id || props.amount}_${chain.chain}_${method.token}`;
    if (getCacheV1(invoice_cache_key)) {
        window.location.href = getUrl(getCacheV1(invoice_cache_key), invoice_cache_key);
        return;
    }
    if (isRequesting.value) return;
    try {
        isRequesting.value = true;
        const params = {
            content_type: props.content_type,
            amount_usdt: props.amount,
            id: props.sku_id,
            token: method?.token,
            chain: chain?.chain
        };
        const res = await createInvoice(params);

        if (res && res.code === 200) {
            if (method.token == "stars") {
                window.Telegram.WebApp.openInvoice(res.data.crypto_address, (status) => {
                    if (status == "cancelled") {
                        // 支付取消
                    } else if (status == "failed") {
                        // 支付失败
                    } else if (status == "paid") {
                        // 支付成功 提示
                        setTimeout(async () => {
                            window.location.reload(); // 刷新页面
                        }, 1500);
                    }
                });
                return;
            }
            const data = res.data;
            setCacheV1(invoice_cache_key, data.invoice_id, 30);
            const url = getUrl(data.invoice_id, invoice_cache_key);
            if (url) {
                window.location.href = url;
            }
        } else {
            console.error('createInvoice failed:', res);
        }
    } catch (error) {
        console.error('createInvoice error:', error);
    } finally {
        isRequesting.value = false;
    }
};
</script>

<style lang="scss" scoped>
@use "@/styles/surfaces" as surface;

.modal-overlay {
  @include surface.dialog-overlay;
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    display: flex;
    align-items: flex-end;
    justify-content: center;
    z-index: 1000;
}

.modal-content {
  @include surface.dialog-panel;
    background: rgba(30, 30, 30, 0.95);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.1);
    position: relative;
    box-shadow: 0 -10px 40px rgba(0, 0, 0, 0.3), 0 8px 32px rgba(0, 0, 0, 0.2);
}

.modal-header-top {
  @include surface.dialog-header;
  margin-bottom: 8px;
}

.close-btn {
  @include surface.close-button;
  transform: none;
    position: relative;

    img {
        width: 100%;
        height: 100%;
    }
}

.modal-header {
  margin: 0;
  gap: 4px;
  min-width: 0;
    text-align: left;
    display: flex;
    align-items: center;
}

.modal-title {
  @include surface.title;
    font-weight: 700;
    color: #ffffff;
}

.back-btn {
  @include surface.close-button;
  margin-right: 0;
    -webkit-appearance: none;
    appearance: none;
    border: none;
    outline: none;
    background: transparent;
    box-shadow: none;
}

.back-icon {
    width: 18px;
    height: 18px;
    transform: rotate(180deg);
    opacity: 0.7;
    filter: invert(1);
}

.methods-grid {
  gap: 6px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
    display: grid;
}

.method-item {
  @include surface.press-feedback;
  padding: 8px;
  border-radius: 12px;
  min-width: 0;
  min-height: 40px;
  gap: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: rgba(45, 45, 45, 0.8);
    border: 1px solid rgba(255, 255, 255, 0.15);
    cursor: pointer;
    text-align: left;

    &.full {
        grid-column: 1 / -1;
    }
}

.left {
  min-width: 0;
  gap: 6px;
    display: inline-flex;
    align-items: center;
}

.icon-wrapper {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    img {
        width: 20px;
        height: 20px;
        object-fit: contain;
    }

    .icon-text {
        font-size: 14px;
        font-weight: 700;
        color: #ffffff;
    }
}

.name {
  min-width: 0;
  overflow-wrap: anywhere;
  line-height: 1.4;
    font-size: 14px;
    font-weight: 700;
    color: #ffffff;
}

.chevron {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
    opacity: 0.5;
    filter: invert(1);
}

.chains-list {
  gap: 6px;
    display: flex;
    flex-direction: column;
}

.chain-item {
  @include surface.press-feedback;
  padding: 8px;
  min-height: 40px;
  gap: 6px;
  border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: rgba(45, 45, 45, 0.8);
    border: 1px solid rgba(255, 255, 255, 0.15);
    cursor: pointer;
    text-align: left;
}

.token {
    font-size: 12px;
    font-weight: 700;
    color: #a0a0a0;
}

// 内容区域容器样式
.content-container {
  min-height: 0;
    position: relative;
    overflow: hidden; // 防止动画过程中出现滚动条
}

// 标题和返回按钮的淡入淡出动画
.fade-slide-enter-active {
    transition: all 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.fade-slide-leave-active {
    transition: all 0.2s cubic-bezier(0.55, 0.085, 0.68, 0.53);
}

.fade-slide-enter-from {
    opacity: 0;
    transform: translateY(-10px);
}

.fade-slide-leave-to {
    opacity: 0;
    transform: translateY(10px);
}

.fade-slide-enter-to,
.fade-slide-leave-from {
    opacity: 1;
    transform: translateY(0);
}

// 水平切换动画
.slide-horizontal-enter-active {
    transition: all 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.slide-horizontal-leave-active {
    transition: all 0.25s cubic-bezier(0.55, 0.085, 0.68, 0.53);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
}

.slide-horizontal-enter-from {
    opacity: 0;
    transform: translateX(30px) scale(0.95);
}

.slide-horizontal-leave-to {
    opacity: 0;
    transform: translateX(-30px) scale(0.95);
}

.slide-horizontal-enter-to,
.slide-horizontal-leave-from {
    opacity: 1;
    transform: translateX(0) scale(1);
}

// 模态框背景淡入淡出动画（优化版）
.modal-enter-active,
.modal-leave-active {
    transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.modal-enter-from {
    opacity: 0;
    backdrop-filter: blur(0px);
}

.modal-leave-to {
    opacity: 0;
    backdrop-filter: blur(0px);
}

.modal-enter-to,
.modal-leave-from {
    opacity: 1;
    backdrop-filter: blur(10px);
}

// 内容区域从底部弹出动画（优化版）
.slide-up-enter-active {
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.1);
}

.slide-up-leave-active {
    transition: all 0.3s cubic-bezier(0.55, 0.055, 0.675, 0.19);
}

.slide-up-enter-from {
    transform: translateY(100%) scale(0.95);
    opacity: 0.8;
}

.slide-up-leave-to {
    transform: translateY(100%) scale(0.95);
    opacity: 0.8;
}

.slide-up-enter-to,
.slide-up-leave-from {
    transform: translateY(0) scale(1);
    opacity: 1;
}

/* 页面跳转加载效果样式 */
.modal-loading {
    position: fixed;
    z-index: 9999;
    inset: 0;
    background: rgba(20, 20, 20, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(8px);
}

.modal-loading-content {
    padding: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.loading-img {
    width: 48px;
    height: 48px;
    margin-bottom: 1vw;
    animation: spin 1s linear infinite;
}

.loading-text {
    color: #fff;
    font-size: 18px;
    margin-top: 6px;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

// 全屏Loading模态框样式
.loading-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(15px);
    -webkit-backdrop-filter: blur(15px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2000; // 确保在支付模态框之上
}

// Loading模态框动画
.loading-modal-enter-active,
.loading-modal-leave-active {
    transition: all 0.3s ease;
}

.loading-modal-enter-from,
.loading-modal-leave-to {
    opacity: 0;
    backdrop-filter: blur(0px);
}

.loading-modal-enter-to,
.loading-modal-leave-from {
    opacity: 1;
    backdrop-filter: blur(4px);
}

/* 与 notFound.vue 一致的加载样式 */
.loadBox {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 10000;
}

.loader {
    margin: auto;
}

.loader:before {
    content: "";
    box-sizing: border-box;
    position: absolute;
    top: 45%;
    left: 50%;
    width: 40px;
    height: 40px;
    margin-top: -20px;
    margin-left: -20px;
    border-radius: 50%;
    border: 4px solid #404040;
    border-top: 4px solid #ffffff;
    animation: spin 1s linear infinite;
}
.close-btn img {
  width: 24px;
  height: 24px;
}
</style>
